import { Entity, TableName } from './../../../models/entities.model';
import { TablePattern } from 'src/app/models/table-patterns';
import { Athlete } from 'src/app/models/athletes.model';
import { Contributor } from '../../contributor/models/contributor.model';
import { Club } from 'src/app/models/clubs.model';
import { League } from 'src/app/models/leagues.model';
import { Referee } from 'src/app/models/referee.model';
import { User } from 'src/app/models/Users';
import { School } from '../../school/models/school.model';


export class EntityHelper {

  static toName(entity: TableName | TablePattern) {
    let sourceName: TableName;
    if (!entity) {
      return '?';
    }
    if (typeof (entity) === 'string') {
      sourceName = entity;
    } else {
      sourceName = entity.source_name as TableName;
    }
    switch (sourceName) {
      case 'athletes': return 'Atleta';
      case 'clubs': return 'Clube';
      case 'contributors': return 'Comissão Técnica';
      case 'leagues': return 'Liga';
      case 'referees': return 'Arbitro';
      case 'users': return 'Usuário';
      case 'schools': return 'Escolinha';
      case 'championships': return 'Campeonato';
    }
  }

  static getGenderPrefix(entity: TableName | TablePattern) {
    let sourceName: TableName;
    if (typeof (entity) === 'string') {
      sourceName = entity;
    } else {
      sourceName = entity.source_name as TableName;
    }
    switch (sourceName) {
      case 'athletes':
      case 'clubs':
      case 'referees':
      case 'championships':
      case 'users': {
        return 'o';
      }

      case 'contributors':
      case 'schools':
      case 'leagues': {
        return 'a';
      }
    }
  }

  static getName(entity: Entity) {
    let name = entity.nickname;
    if (!name) {
      name = entity.name;
    }
    if (!name) {
      name = entity.email;
    }
    return name;

  }

  static getInstance<T extends TablePattern = Entity>(entity: TablePattern): T {

    switch (entity.source_name) {
      case 'athletes': return new Athlete(entity) as any;
      case 'contributors': return new Contributor(entity) as any;
      case 'clubs': return new Club(entity) as any;
      case 'leagues': return new League(entity) as any;
      case 'referees': return new Referee(entity) as any;
      case 'users': return new User(entity) as any;
      case 'schools': return new School(entity) as any;
      default: throw new Error('Entity source name is not implemented');
    }
  }

}
